import { render } from "./TermsDialog.vue?vue&type=template&id=6eff2686&scoped=true"
import script from "./TermsDialog.vue?vue&type=script&lang=js"
export * from "./TermsDialog.vue?vue&type=script&lang=js"

import "./TermsDialog.vue?vue&type=style&index=0&id=6eff2686&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eff2686"]])

export default __exports__